import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { related as relatedPropType } from 'lib/CustomPropTypes';
import RelatedItem from '../Related/Item';


const GiftGuide = ({ items }) => {
  const title = i18next.t('Trending Gift Guides');
  const linkTracking = 'recommended_giftguide';

  return (
    !!items.length
    && (
      <section className="gift-guide__wrapper bg-white mt8">
        <div className="gift-guide pv8">
          <h2 className="gift-guide__title tc color-primary publico-hed fs-italic fw3 f8 f9-m ma0 pb8 pb9-m">
            {title}
          </h2>
          <div className="gift-guide__items df flex-wrap flex-nowrap-m justify-center">
            {items && items.slice(0, 4).map((item) => (
              <RelatedItem
                key={item.title}
                item={item}
                linkTracking={linkTracking}
                isGiftGuide
                singleItem={false}
              />
            ))}
          </div>
        </div>
      </section>
    )
  );
};

GiftGuide.propTypes = {
  items: PropTypes.arrayOf(relatedPropType),
};

GiftGuide.defaultProps = {
  items: [],
};

export default GiftGuide;
